export default __webpack_public_path__ + "static/media/statistics.e21e5208.svg";